import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useEffect } from "react";
import MainLayout from "../layouts/MainLayout";

// Screen Imports
import AuthScreen from "../pages/AuthScreen";
import LandingPage from "../pages/LandingPage";
import LoginScreen from "../pages/LoginScreen";
import PhoneLoginScreen from "../pages/PhoneLoginScreen";
import SplashScreen from "../pages/SplashScreen";
import SingUpScreen from "../pages/SingUpScreen";
import ProfileScreen from "../pages/ProfileScreen";
import EditProfileScreen from "../pages/EditProfileScreen";
import LocationsScreen from "../pages/LocationsScreen";
import AddEditLocationScreen from "../pages/AddEditLocationScreen";
import OTPVerifyScreen from "../pages/OTPVerifyScreen";
import DashboardScreen from "../pages/DashboardScreen";
import TrackOrderScreen from "../pages/TrackOrderScreen";
import OrderHistoryScreen from "../pages/OrderHistoryScreen";
import OrderSuccessScreen from "../pages/OrderSuccessScreen";
import OrderDetailsScreen from "../pages/OrderDetailsScreen";

// Guards & State
import MobileOnlyRoute from "../guards/MobileOnlyRoute";
import ProtectedRoute from "../guards/ProtectedRoute";
import { useAuthStore } from "../features/auth/authStore";
import { useOrderStore } from "../features/orders/orderStore";
import { LoadingOverlay } from "../components/LoadingOverlay";
import CreateNewOrder from "../pages/CreateNewOrder";

export default function AppRouter() {
  const initializeAuth = useAuthStore((state) => state.initializeAuth);
  const isAuthLoading = useAuthStore((state) => state.isLoading);
  const isOrderLoading = useOrderStore((state) => state.isLoading);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return (
    <Router>
      <MobileOnlyRoute>
        <Routes>
          {/* --- PUBLIC ROUTES --- */}
          <Route path="/" element={<SplashScreen />} />
          <Route path="/auth" element={<AuthScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/login/phone" element={<PhoneLoginScreen />} />
          <Route path="/signup" element={<SingUpScreen />} />
          <Route path="/verify" element={<OTPVerifyScreen />} />

          {/* --- PROTECTED ROUTES WITH LAYOUT --- */}
          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/home" element={<DashboardScreen />} />
            <Route path="/order/history" element={<OrderHistoryScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/order/track" element={<TrackOrderScreen />} />
          <Route path="/profile/edit" element={<EditProfileScreen />} />
          <Route path="/profile/locations" element={<LocationsScreen />} />
          <Route path="/profile/locations/add" element={<AddEditLocationScreen />} />
          <Route path="/profile/locations/edit/:id" element={<AddEditLocationScreen />} />
          </Route>

          {/* --- PROTECTED ROUTES FULL SCREEN --- */}
          <Route
            element={
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            }
          >
            <Route path="/order/new" element={<CreateNewOrder />} />
            <Route path="/order/success" element={<OrderSuccessScreen />} />
            <Route path="/order/details" element={<OrderDetailsScreen />} />
          </Route>

          <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/"} replace />} />
        </Routes>
      </MobileOnlyRoute>
      
      <LoadingOverlay open={isOrderLoading || isAuthLoading} />
    </Router>
  );
}